var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.417,
    height: 41,
    viewBox: "0 0 44.417 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-calendar",
    "data-name": "Icon ionic-ios-calendar",
    transform: "translate(-3.375 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M43.521,6.75H39.25V9.313a.857.857,0,0,1-.854.854H36.688a.857.857,0,0,1-.854-.854V6.75h-20.5V9.313a.857.857,0,0,1-.854.854H12.771a.857.857,0,0,1-.854-.854V6.75H7.646a4.283,4.283,0,0,0-4.271,4.271V40.062a4.283,4.283,0,0,0,4.271,4.271H43.521a4.283,4.283,0,0,0,4.271-4.271V11.021A4.283,4.283,0,0,0,43.521,6.75Zm.854,32.031a2.142,2.142,0,0,1-2.135,2.135H8.927a2.142,2.142,0,0,1-2.135-2.135V19.562a.857.857,0,0,1,.854-.854H43.521a.857.857,0,0,1,.854.854Z",
    transform: "translate(0 1.167)",
    fill: "#00bfef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M12.417,5.354a.857.857,0,0,0-.854-.854H9.854A.857.857,0,0,0,9,5.354V7.917h3.417Z",
    transform: "translate(2.917)",
    fill: "#00bfef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M28.167,5.354a.857.857,0,0,0-.854-.854H25.6a.857.857,0,0,0-.854.854V7.917h3.417Z",
    transform: "translate(11.083)",
    fill: "#00bfef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/CalendarBlue.383bce9d8c341f132c786d31e28c018a.svg";
export { ForwardRef as ReactComponent };